const main = () => {
    if(document.querySelector('.c-buttons-login') === null) return;
    document.querySelectorAll('.c-buttons-login').forEach((obj) => {
        obj.querySelector('button').addEventListener('click', () => {
            if(obj.querySelector('.c-buttons-login-submenu')){
                if(obj.dataset.submenu == 'active'){
                    obj.dataset.submenu = '';
                }else{
                    obj.dataset.submenu = 'active';
                }
            } else{
                window.location.href = obj.dataset.mypageUrl;
            }
        });
    });
}

export default main;
